// extracted by mini-css-extract-plugin
export default {"root":"Challenge_root__kTUtK","name":"Challenge_name__YfONc"};